import { RouteInfo } from './immobilier-routes.config';

export const PAYMENT_ROUTES: RouteInfo[] = [
  // {
  //   path: '/homecpnt/payment-dashboard',
  //   title: 'Tableau de bord',
  //   icon: 'dashboard',
  //   class: ''
  // },

  /*  {
      path: '/homecpnt/situation-forfaitaire',
      title: 'Situation Forfaitaire',
      icon: 'history',
      class: ''
    },
  */
  {
    path: '/homecpnt/payment-reporting',
    title: 'Reporting Transactions',
    icon: 'history',
    class: ''
  }
  // {
  //   path: '/homecpnt/api-docs',
  //   title: 'Documentation API',
  //   icon: 'description',
  //   class: ''
  // }
];

export const ADMIN_PAYMENT_ROUTES: RouteInfo[] = [
  {
    path: '/homecpnt/payment-admin-dashboard',
    title: 'Tableau de bord Admin',
    icon: 'dashboard',
    class: ''
  },
  {
    path: '/homecpnt/payment-admin-reporting',
    title: 'Reporting Admin',
    icon: 'history',
    class: ''
  },
];

export const SUPERVISEUR_PAYMENT_ROUTES: RouteInfo[] = [
  // {
  //   path: '/homecpnt/payment-admin-dashboard',
  //   title: 'Tableau de bord Admin',
  //   icon: 'dashboard',
  //   class: ''
  // },
  {
    path: '/homecpnt/payment-admin-reporting',
    title: 'Reporting Admin',
    icon: 'history',
    class: ''
  },
];

